<div class="menu d-flex flex-column flex-shrink-0 p-3 text-white" id="menuBar">
  <app-accordion-menu [options]="options" [menus]="menus" [activeRoute]="currentRoute">
  </app-accordion-menu>
</div>
